import React from "react";
import cn from "classnames";

export default class Viewer extends React.Component {
  componentDidMount() {
    this.ctx = this.canvas.getContext("2d");
    this.draw(this.props.angle, this.props.corner, this.props.cut);
  }

  _drawAngle(x1, y1, r, angle, color, dash = []) {
    const x = x1 + r * Math.cos(Math.PI * angle / 180.0);
    const y = y1 + r * Math.sin(Math.PI * angle / 180.0);
    this.ctx.setLineDash(dash);
    this.ctx.strokeStyle = color;
    this.ctx.beginPath();
    this.ctx.moveTo(x1, y1);
    this.ctx.lineTo(x, y);
    this.ctx.stroke();
    return { x, y };
  }

  _drawWall({ x: x0, y: y0 }, { x: x1, y: y1 }, r, theta, color) {
    this.ctx.save();
    this.ctx.setLineDash([]);
    this.ctx.beginPath();
    this.ctx.strokeStyle = color;
    this.ctx.translate(x0, y0);
    this.ctx.moveTo(x1, y1);
    this.ctx.lineTo(x1 + r, y1);
    this.ctx.stroke();

    this._drawAngle(x1, y1, r, theta, color);
    this.ctx.restore();
  }

  _drawLabel(text, { x, y }) {
    this.ctx.save();
    this.ctx.translate(x, y);
    this.ctx.font = "100 12px sans-serif";
    this.ctx.textAlign = "end";
    this.ctx.fillText(text, 0, 0);
    this.ctx.restore();
  }

  _drawMolding(
    angle,
    { x: x0 = 0, y: y0 = 0 },
    { x: x1 = 0, y: y1 = 0 },
    length = 225,
    width = 12
  ) {
    this.ctx.save();
    this.ctx.translate(x0, y0);
    this.ctx.globalAlpha = 0.1;

    this.ctx.rotate(angle * Math.PI / 180);
    this.ctx.fillRect(x1, y1, length, width);
    this.ctx.restore();
  }

  draw(angle, corner, cut) {
    const length = this.canvas.width * 0.4;
    const thickness = length * 0.075;
    const padding = 25;
    const x0 = length + padding;
    const y0 = length / 2 - thickness * 2;
    const x1 = x0;
    const y1 = y0 + length;

    const miter = (180 - angle) / 2;
    const complement = 90 - miter;

    // Clear the canvas
    this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);

    // Miter Saw
    this._drawLabel("Miter Saw", { x: x0 + length, y: y0 - 8 });
    this._drawWall({ x: x0, y: y0 }, { x: 0, y: 0 }, length, 180, "#2780e3");

    if (cut === "right") {
      this._drawMolding(0, { x: x0, y: y0 }, { x: -length, y: 0 });
    }

    if (cut === "left") {
      this._drawMolding(0, { x: x0, y: y0 }, { x: -65, y: 0 });
    }

    if (
      (corner === "inside" && cut === "right") ||
      (corner === "outside" && cut === "left")
    ) {
      this._drawAngle(x0, y0, length / 2, complement + 90, "#ff2e12", [1, 7]);
    }

    if (
      (corner === "inside" && cut === "left") ||
      (corner === "outside" && cut === "right")
    ) {
      this._drawAngle(x0, y0, length / 2, miter, "#ff2e12", [1, 7]);
    }

    // Wall

    this._drawWall({ x: x1, y: y1 }, { x: 0, y: 0 }, length, angle, "#2780e3");

    if (corner === "outside") {
      this._drawLabel("Wall", { x: x1 + length, y: y1 + thickness + 8 });
      this._drawAngle(x1, y1, length / 2, complement + 180, "#ff2e12", [1, 7]);
      if (cut === "right") {
        this._drawMolding(angle, { x: x1, y: y1 }, { x: 0, y: 0 }, 160);
      } else {
        this._drawMolding(0, { x: x1, y: y1 }, { x: 0, y: -thickness }, 160);
      }
    } else {
      this._drawLabel("Wall", { x: x1 + length, y: y1 - 8 });
      this._drawAngle(x1, y1, length / 2, complement, "#ff2e12", [1, 7]);
      if (cut === "left") {
        this._drawMolding(
          angle,
          { x: x1, y: y1 },
          { x: 0, y: -thickness },
          160
        );
      } else {
        this._drawMolding(0, { x: x1, y: y1 }, { x: 0, y: 0 }, 160);
      }
    }
  }

  componentDidUpdate() {
    this.draw(this.props.angle, this.props.corner, this.props.cut);
  }

  render() {
    let angle = (180 - this.props.angle) / 2;
    if (this.props.angle <= 90) {
      angle = this.props.angle / 2;
    }
    return (
      <div>
        <h3 className="is-size-4 is-capitalized">
          {this.props.side} Side Of Molding - {angle}&deg;
        </h3>
        <canvas
          title="Click to edit details"
          className={cn({
            active: this.props.editing && this.props.focus === this.props.side
          })}
          ref={el => (this.canvas = el)}
          height={400}
          width={400}
          onClick={this.props.onClick}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/AngleViewer.js